/** An Enumeration of all available emojis */
export enum EmojiType {
  UNHAPPY = 'unhappy',
  NEUTRAL = 'neutral',
  HAPPY = 'happy',
}
